import styled from 'styled-components';
import figure from '../../../assets/images/components/figure-bank-working@2x.png';

export const Wrap = styled.div`
  overflow: hidden;
  background: linear-gradient(to bottom, #082033, #1a5485);
  min-height: 100vh;
`;

export const Figure = styled.div`
  width: 303px;
  height: 349px;
  margin: 60px auto 20px auto;

  background-image: url(${figure});
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;

  @media screen and (max-width: 280px) {
    width: 279px;
    height: 352px;
  }
`;

export const Text = styled.div`
  color: #fff;
  text-align: center;
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
`;

export const SubText = styled.div`
  margin-top: 16px;
  color: #fff;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
`;
